import type { UserRole } from '@/types';

export function isPlatformEditorRole(role: string | undefined | null): boolean {
  return String(role ?? '').toLowerCase().trim() === 'editor';
}

/** Rôles avec espace création (formations, podcasts, parcours) sans apprenants ni publication publique. */
export const EDITOR_CREATOR_ROLES: UserRole[] = ['editor'];

export function roleQualifiesForEditorCreatorNav(role: string | undefined | null): boolean {
  return isPlatformEditorRole(role);
}
